<style lang="less">
  @import "./css/common.less";
</style>
<template>
  <div class="garment common-content">
    <navMenu></navMenu>
    <div class="content">
      <div class="banner-items">
        <img src="../assets/images/banner_Garment.jpg">
        <div class="banner-title font-large">
          <span>GARMENT</span>
        </div>
      </div>
      <div class="text-content">
        <div class="pc-items">
          <ContactBox></ContactBox>
        </div>
        <div class="article">
          <div class="bread-crumbs">
            <span class="pointer" @click="goToIndex">HOME></span>
            <span>GARMENT</span>
          </div>
          <div class="article-content">
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              School uniform
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Corporate uniform
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Workwear
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Saloon wear
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Fashion wear
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Health care wear
            </div>
          </div>
          <div class="tips">With our expertise in producing high-quality fabrics we can always ensure that only the best components are used in our garments.</div>
          <div class="mb-items">
            <ContactBox></ContactBox>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import ContactBox from '../components/contactBox'
export default {
  data () {
    return {
      // url: ''
    }
  },
  components: {
    NavMenu,
    Footer,
    ContactBox
  },
  methods: {
    goToIndex(){
      this.$router.push('/index')
    }
  },
  watch: {},
  mounted () {
    
  }
}
</script>
<style lang="less">
  .garment{
    .content .text-content .article .article-content{
      .items{
        margin-bottom: 10px;
        color: #333;
        font-weight: bold;
        display: flex;
        align-items: center;
        img{
          margin-right: 10px;
        }
      }
    } 
    .article .tips{
      color: #666;
    }
  }
</style>
